import { TablePagination, TableFooter, TableRow } from "@mui/material";

const Pagination = ({ rows, rowsPerPage, page, onPageChange, onRowsPerPageChange }) => {
    const options = [25, 50, 100, { label: 'Todos', value: rows }]
    if(rows < 25) return
    return(
        <TableFooter>
            <TableRow>
                <TablePagination
                    rowsPerPageOptions={options}
                    rowsPerPage={rowsPerPage}
                    count={rows}
                    labelRowsPerPage={'Filas por página'}
                    page={page}
                    showFirstButton={true}
                    showLastButton={true}
                    onPageChange={onPageChange}
                    onRowsPerPageChange={onRowsPerPageChange}
                />
            </TableRow>
        </TableFooter>
    )
}

export default Pagination;